export var YEAR = 'year';

export var DATE = 'date';

export var HOUR = 'hour';

export var MINUTES = 'minutes';


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/src/constants/date-picker-view.js
// module id = 1276
// module chunks = 0